import * as React from "react";

import { Lightbulb24Filled, Lightbulb24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const ApsHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "ApsHub" */ "./ApsHubApp");
    return { default: namedExport.ApsHubApp };
});

export const ApsHub: TeamAppConfig = {
    title: "APS Hub",
    regularIcon: Lightbulb24Regular,
    filledIcon: Lightbulb24Filled,
    description:
        "Search and inspect APS (Availability Planning Service) requests, workitems, resources, " +
        "and availability units across Prod, Gallatin, and ITAR environments.",
    team: "APS",
    publicId: "Exchange\\CentralAdmin",
    owner: "o365aps@microsoft.com",
    role: "*",
    tags: ["O365APS"],
    app: ApsHubApp,
    path: "/APS/ApsHub"
};
